var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(0%, 29.019165%, 52.548218%)",
    fillOpacity: 1,
    d: "M 16.5 9 C 16.5 13.140625 13.140625 16.5 9 16.5 C 4.859375 16.5 1.5 13.140625 1.5 9 C 1.5 4.859375 4.859375 1.5 9 1.5 C 13.140625 1.5 16.5 4.859375 16.5 9 Z M 9.75 7.5 L 9.75 12.75 L 8.25 12.75 L 8.25 7.5 Z M 9.75 6.75 L 9.75 5.25 L 8.25 5.25 L 8.25 6.75 Z M 9.75 6.75 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.0fff7df0ff3e5955b8361a0110b6e998.svg";
export { ForwardRef as ReactComponent };